import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, createStaticVNode as a, normalizeClass as o, openBlock as s } from "vue";
//#region ../src/icons/dialpad-sparkle.vue
var c = {
	name: "DtIconDialpadSparkle",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, l = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], u = ["fill"], d = ["fill"], f = ["fill"], p = ["id"], m = ["id"], h = ["id"];
function g(e, t, n, c, g, _) {
	return s(), r("svg", {
		"aria-label": n.ariaLabel,
		class: o([_.iconSizeClass, "d-icon d-icon--dialpad-sparkle"]),
		"data-qa": _.dataQA,
		"aria-hidden": _.ariaHidden,
		role: "img",
		"data-name": "Dialpad Sparkle",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("path", {
			d: "M18.527 2c.1 0 .186.067.215.163a4.786 4.786 0 0 0 3.09 3.144.24.24 0 0 1 .168.227.24.24 0 0 1-.168.228 4.786 4.786 0 0 0-3.058 3.045.263.263 0 0 1-.247.183.263.263 0 0 1-.247-.183 4.785 4.785 0 0 0-3.018-3.034.254.254 0 0 1-.175-.24c0-.109.072-.204.175-.238a4.785 4.785 0 0 0 3.05-3.132.227.227 0 0 1 .215-.163Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, u),
		i("path", {
			d: "M9.005 4.784a.46.46 0 0 1 .436.331c.936 3.039 3.298 5.441 6.295 6.406a.485.485 0 0 1 .339.46c0 .21-.14.395-.34.46-2.93.943-5.253 3.26-6.23 6.204a.533.533 0 0 1-.5.372.533.533 0 0 1-.5-.372c-.967-2.917-3.257-5.22-6.15-6.18A.515.515 0 0 1 2 11.98c0-.222.146-.416.355-.486 2.959-.981 5.287-3.367 6.214-6.379a.46.46 0 0 1 .436-.33Z",
			fill: `url(#${e.uniqueID}b)`
		}, null, 8, d),
		i("path", {
			d: "M18.528 15.01c.099 0 .185.067.215.163a4.786 4.786 0 0 0 3.09 3.144.24.24 0 0 1 .167.227.24.24 0 0 1-.167.227 4.785 4.785 0 0 0-3.059 3.046.263.263 0 0 1-.247.183.263.263 0 0 1-.246-.183 4.786 4.786 0 0 0-3.019-3.034.254.254 0 0 1-.175-.24c0-.109.072-.205.175-.239a4.785 4.785 0 0 0 3.05-3.131.227.227 0 0 1 .216-.163Z",
			fill: `url(#${e.uniqueID}c)`
		}, null, 8, f),
		i("defs", null, [
			i("linearGradient", {
				id: `${e.uniqueID}a`,
				x1: "2",
				y1: "2",
				x2: "22",
				y2: "22",
				gradientUnits: "userSpaceOnUse"
			}, [...t[0] || (t[0] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, p),
			i("linearGradient", {
				id: `${e.uniqueID}b`,
				x1: "2",
				y1: "2",
				x2: "22",
				y2: "22",
				gradientUnits: "userSpaceOnUse"
			}, [...t[1] || (t[1] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, m),
			i("linearGradient", {
				id: `${e.uniqueID}c`,
				x1: "2",
				y1: "2",
				x2: "22",
				y2: "22",
				gradientUnits: "userSpaceOnUse"
			}, [...t[2] || (t[2] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, h)
		])
	], 10, l);
}
var _ = /* @__PURE__ */ n(c, [["render", g]]);
//#endregion
export { _ as default };

//# sourceMappingURL=dialpad-sparkle.js.map